import { WireCreditor } from '@treasury/domain/wires';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-footer';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../../components/confirmation-container';
import './creditor-data-readonly';

export const tagName = 'creditor-confirm-step';
@customElement(tagName)
export class CreditorConfirmStep extends TmBaseComponent {
    @property({ type: Object })
    public creditor: WireCreditor = new WireCreditor();

    protected render() {
        return html`<confirmation-container .headingText=${'Creditor Submitted'}>
                <creditor-data-readonly .creditor=${this.creditor}></creditor-data-readonly>
            </confirmation-container>
            <tm-footer
                .buttonConfig=${[
                    {
                        text: 'Create another creditor',
                        importance: 'secondary',
                        onClick: () => {
                            this.dispatchEvent(new CustomEvent('create-creditor'));
                        },
                    },
                    {
                        text: 'View creditors',
                        importance: 'secondary',
                        onClick: () => {
                            this.dispatchEvent(new CustomEvent('view-creditors'));
                        },
                    },
                ]}
            ></tm-footer>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: CreditorConfirmStep;
    }
}
